<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} из {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{ test.description }}
                    </div>
                    <div class="d-flex col-12 col-xl-8 pt-4 mt-xl-0 mt-2 mb-3 text-center testcard-border" style="height: 40vh; min-height: 40vh">
                         <div v-if="step=='showDigits'" class="col-12 test-text-xlarge text-center align-self-center">
                            <transition name="fade300">
                                <div v-show="digitVisible">
                                    {{ currentElement }}
                                </div>
                            </transition>
                        </div>
                        <div v-else-if="step=='countdown'" class="col-12  text-center align-self-center">
                            <p style="font-size: min(10vw, 10vh);">Приготовься!</p>
                            <p style="font-size: 10vh;">{{ countdown }}</p>
                        </div>
                        <div v-else-if="step=='askAnswer'" class="col-12  text-center align-self-center">
                            <base-input alternative=""
                                id="answer"
                                class="ml-auto mr-auto mt-8"
                                style="max-width: 200px"
                                placeholder="Введи ответ"
                                v-model="answer"
                            />
                            <button
                                    class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                                    @click="checkAnswer">
                                <i class="ni ni-send mr-2"></i>{{ $t('accept_answer') }}
                            </button>
                        </div>
                        <div v-else-if="step=='result'" class="col-12  text-center align-self-center">
                            <p
                                class="ml-auto mr-auto mt-8"
                                style="font-size: min(7vw, 7vh);"
                                v-html="resultText"
                            >
                            </p>
                            <button
                                    class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                                    @click="next">
                                <i class="ni ni-button-play mr-2"></i>Далее...
                            </button>
                        </div>
                    </div>

                </div>

            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
                <button
                        class="btn btn-info"
                        @click="skip"
                >
                    {{ $t('omit_task') }} &rarr;
                </button>
        </div>
    </div>

</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
    // import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test41',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },

        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            currentElement: null,
            step: null,
            countdown: 0,
            answer: null,
            resultText: '',
            digitVisible: false,

            audio: new Audio(),
            forceRenderKey: 0,

            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',

            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                // console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            answerElement: function () {
                return this.getBy('isright', 1, this.testelements)
            },

            answers: function () {
                // console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },

        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                this.currentElement = null
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    // this.play(this.mainElement.audio)
                    // console.log(this.taskIdx, this.currentTask, this.mainElement)
                    let elements = this.currentTask.testtask.replace(/\s/g,"прошел")
                    elements = elements.split(/(?=[+*\-:x/])/g)
                    await this.readyScreen()
                    await this.showByInterval(elements, this.currentTask.intvl | 0);
                    this.askAnswer()
                } else {
                    this.$emit('testComplete')
                }
            },

            async readyScreen () {
                this.step = 'countdown'
                for (this.countdown = 3; this.countdown > 0 ; this.countdown--) {
                    await this.sleep(1000)
                 }
            },

            async showByInterval(elements, intvl) {
                this.digitVisible = false
                this.step = 'showDigits'
                intvl = parseInt(intvl)
                if(intvl) await this.sleep(500)
                for (let index = 0; index < elements.length; index++) {
                    this.currentElement = ''  // между цифрами показываем пустой экран, чтобы разделить 2 одинаковых цифры подряд
                    this.currentElement = elements[index].replace(/\+/g, '')
                    this.digitVisible = true
                    if(intvl) {
                        console.log('sleep')
                        await this.sleep(intvl*1000 - 200)
                    }
                    this.digitVisible = false
                    await this.sleep(300)
                }


            },

            askAnswer () {
                this.answer = ''
                this.step = 'askAnswer'
            },

            checkAnswer () {
                if (this.answer == this.answerElement.word) {
                    this.resultText = `Правильно!`
                    this.step = 'result'
                    this.$emit('correctAnswer')
                    if (this.answerElement.audio) {
                        this.play(this.answerElement.audio)
                    } else {
                        this.play(this.okChord)
                    }
                } else {
                    this.resultText = `Неправильный ответ.<br/> ${this.answer} ≠  ${this.answerElement.word}`
                    this.step = 'result'
                    this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильный ответ. ${this.answer} ≠  ${this.answerElement.word}`})
                    this.play(this.errorChord)
                }
            },

            next () {
                this.taskIdx++
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

        },
    }
</script>
